import constantApi from "../api/constant-api";

const getConstants = async () => {
    const resp = await constantApi.get();
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}


const getUserRole = async () => {
	try {
		const { constants } = await constantApi.get();
		const { userRole } = constants;
		return { userRole };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getUserStatus = async () => {
	try {
		const { constants } = await constantApi.get();
		const { userStatus } = constants;
		return { userStatus };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getTemplateType = async () => {
	try {
		const { constants } = await constantApi.get();
		// console.log(' constants ',constants);
		const { templateType } = constants;
		return { templateType };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getMenuType = async () => {
	try {
		const { constants } = await constantApi.get();
		const { menuType } = constants;
		return { menuType };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

/**
 * NMU-559: menu and footer-link items can point at the News listing filtered to
 * one category, so both forms need the news taxonomy next to the type list.
 * One call, both lists — they are served by the same endpoint.
 */
const getMenuAndNewsType = async () => {
	try {
		const { constants } = await constantApi.get();
		const { menuType, newsType } = constants;
		return { menuType, newsType };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const sendEmailResetPassword = async (payload) => {
    const resp = await constantApi.sendEmailResetPassword(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
};

const constantService = {
    getUserStatus,
    getUserRole,
    getConstants,
	getTemplateType,
	getMenuType,
	getMenuAndNewsType,
	sendEmailResetPassword
};

export default constantService;